import { Box, Text } from '@wix/design-system';
import React from 'react';

import type { TFunction } from './../../../../ricos-types/commonTypes';

import { SECTION_EMPTY_STATE } from '../../data-hooks/data-hooks';

export const SectionEmptyState: React.FC<{ t: TFunction }> = ({ t }) => {
  return (
    <Box
      dataHook={SECTION_EMPTY_STATE}
      direction="vertical"
      margin="SP4"
      gap="SP2"
      verticalAlign="middle"
      textAlign="center"
    >
      <Text size="small" weight="bold">
        {t('LinkSettings_Sections_Empty_Text1')}
      </Text>
      <Text size="small" weight="thin">
        {t('LinkSettings_Sections_Empty_Text2')}
      </Text>
    </Box>
  );
};
